/**
 * Email Marketing Consent Utilities
 * Helper functions for consent detection and validation
 */

import { UserProfile } from '../types/user';

/**
 * Check if user needs to provide email marketing consent
 * 
 * Returns true if:
 * - emailMarketingConsent is undefined (user hasn't been prompted)
 * - emailMarketingConsentVersion is not "v1" (consent terms have changed)
 * 
 * @param profile - User profile to check
 * @returns true if user needs to provide consent, false otherwise
 */
export function needsConsent(profile: UserProfile | null): boolean {
  if (!profile) {
    return false;
  }

  // Check if consent field is missing
  if (profile.emailMarketingConsent === undefined) {
    return true;
  }

  // Check if consent version is outdated
  if (profile.emailMarketingConsentVersion !== 'v1') {
    return true;
  }

  return false;
}
